import { Moment } from 'moment';
import { Certificate } from '../../../common/certificates/models/Certificate';
import { PublicKey } from '../../../common/certificates/models/valueObjects/PublicKey';

export class OrganizationCertificate extends Certificate {
  constructor(
    id: number,
    subject: string,
    issuer: string,
    publickey: PublicKey,
    fingerprint: string | null,
    expiryDate: Moment | null,
    digestAlgorithm: string | null,
    private readonly matchedCertificatesCount: number
  ) {
    super(id, subject, issuer, publickey, fingerprint, expiryDate, digestAlgorithm);
  }

  getMatchedCertificatesCount() {
    return this.matchedCertificatesCount;
  }
}
